/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Add_JobInputs */

const en_jobs_add_job = /** @type {(inputs: Jobs_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Job`)
};

const de_jobs_add_job = /** @type {(inputs: Jobs_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle hinzufügen`)
};

const fr_jobs_add_job = /** @type {(inputs: Jobs_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un emploi`)
};

const es_jobs_add_job = /** @type {(inputs: Jobs_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir empleo`)
};

const it_jobs_add_job = /** @type {(inputs: Jobs_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi lavoro`)
};

const nl_jobs_add_job = /** @type {(inputs: Jobs_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baan toevoegen`)
};

const pl_jobs_add_job = /** @type {(inputs: Jobs_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj ofertę`)
};

const fi_jobs_add_job = /** @type {(inputs: Jobs_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää työpaikka`)
};

const da_jobs_add_job = /** @type {(inputs: Jobs_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilføj job`)
};

const sv_jobs_add_job = /** @type {(inputs: Jobs_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägg till jobb`)
};

/**
* | output |
* | --- |
* | "Add Job" |
*
* @param {Jobs_Add_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_add_job = /** @type {((inputs?: Jobs_Add_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Add_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_add_job(inputs)
	if (locale === "fr") return fr_jobs_add_job(inputs)
	if (locale === "es") return es_jobs_add_job(inputs)
	if (locale === "it") return it_jobs_add_job(inputs)
	if (locale === "nl") return nl_jobs_add_job(inputs)
	if (locale === "pl") return pl_jobs_add_job(inputs)
	if (locale === "fi") return fi_jobs_add_job(inputs)
	if (locale === "da") return da_jobs_add_job(inputs)
	if (locale === "sv") return sv_jobs_add_job(inputs)
	return en_jobs_add_job(inputs)
});